(function () {
  'use strict';

  var root = (window.BangkokTheme && window.BangkokTheme.root) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toggle = document.querySelector('[data-nav-toggle]');
  var panel = document.getElementById('MobileNav');

  function setNavOpen(open) {
    if (!toggle || !panel) return;
    panel.setAttribute('data-open', open ? 'true' : 'false');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
    if (open) {
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    }
  }

  if (toggle && panel) {
    toggle.addEventListener('click', function () { setNavOpen(panel.getAttribute('data-open') !== 'true'); });
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || panel.getAttribute('data-open') !== 'true') return;
      var items = panel.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); toggle.focus(); }
    });
    window.addEventListener('resize', function () { if (window.innerWidth > 900) setNavOpen(false); });
  }

  var transparentHeaders = document.querySelectorAll('.header--transparent-home');
  function updateHeaderState() {
    transparentHeaders.forEach(function (header) { header.classList.toggle('is-scrolled', window.scrollY > 12); });
  }
  if (transparentHeaders.length) {
    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
  }

  var lastCartTrigger = null;
  function drawer() { return document.querySelector('[data-cart-drawer]'); }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
  }

  function setDrawerOpen(open, trigger) {
    var el = drawer();
    if (!el) return;
    if (open) lastCartTrigger = trigger || document.activeElement;
    el.setAttribute('data-open', open ? 'true' : 'false');
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('cart-drawer-open', open);
    if (open) {
      var close = el.querySelector('[data-cart-close]');
      if (close) close.focus();
    } else if (lastCartTrigger && typeof lastCartTrigger.focus === 'function') {
      lastCartTrigger.focus();
    }
  }

  function refreshHeaderCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.hidden = count < 1;
    });
  }

  function refreshDrawer(openAfter) {
    return Promise.all([
      fetch(root + 'cart?section_id=cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.text(); }),
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    ]).then(function (responses) {
      var html = responses[0];
      var cart = responses[1];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer]');
      var current = drawer();
      if (fresh && current) current.replaceWith(fresh);
      refreshHeaderCount(cart.item_count);
      if (openAfter) setDrawerOpen(true);
      return cart;
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && drawer()) { e.preventDefault(); setDrawerOpen(true, open); return; }
    var close = e.target.closest('[data-cart-close], [data-cart-backdrop]');
    if (close && drawer()) { e.preventDefault(); setDrawerOpen(false); return; }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove && drawer()) {
      e.preventDefault();
      var line = Number(remove.getAttribute('data-line'));
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function (r) { if (!r.ok) throw new Error('Cart update failed'); return refreshDrawer(true); })
        .catch(function () { window.location.href = root + 'cart'; });
    }
  });

  document.addEventListener('change', function (e) {
    var qty = e.target.closest('[data-cart-qty]');
    if (!qty || !drawer()) return;
    var line = Number(qty.getAttribute('data-line'));
    var quantity = Math.max(0, Number(qty.value || 0));
    fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { if (!r.ok) throw new Error('Cart update failed'); return refreshDrawer(true); })
      .catch(function () { window.location.href = root + 'cart'; });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.buy-form');
    if (!form || !drawer() || !(window.BangkokTheme && window.BangkokTheme.cartDrawer)) return;
    if (form.querySelector('input[name="return_to"][value="/checkout"]')) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw new Error(x.description || 'Unable to add to cart'); }); return r.json(); })
      .then(function () { return refreshDrawer(true); })
      .catch(function (err) {
        var region = form.querySelector('[data-buy-error]');
        if (region) { region.textContent = err.message; region.hidden = false; }
        else window.alert(err.message);
      })
      .finally(function () { if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } });
  });

  document.addEventListener('keydown', function (e) {
    var cart = drawer();
    if (e.key === 'Tab' && cart && cart.getAttribute('data-open') === 'true') {
      var focusable = getFocusable(cart.querySelector('.cart-drawer__panel'));
      if (focusable.length) {
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    if (e.key === 'Escape') {
      if (cart && cart.getAttribute('data-open') === 'true') setDrawerOpen(false);
      if (panel && panel.getAttribute('data-open') === 'true') { setNavOpen(false); if (toggle) toggle.focus(); }
    }
  });
})();
